import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "94",
  height: "94",
  viewBox: "0 0 94 94",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<rect x=\"32.3472\" y=\"27.8467\" width=\"14.0574\" height=\"13.8149\" fill=\"#D7D8DB\"></rect><rect x=\"47.2834\" y=\"27.8467\" width=\"14.0574\" height=\"13.8149\" fill=\"#D7D8DB\"></rect><path d=\"M18.965 54.108V29.1168C18.965 27.8605 19.9051 26.802 21.1477 26.617C24.0325 26.1876 29.184 25.2884 32.9077 23.8966C37.0361 22.3536 42.9195 18.8933 45.5233 17.3101C46.3391 16.814 47.3618 16.814 48.1777 17.3101C50.7815 18.8933 56.6648 22.3536 60.7932 23.8966C64.5169 25.2884 69.6684 26.1876 72.5532 26.617C73.7959 26.802 74.736 27.8594 74.736 29.1157V54.0667C74.736 59.6225 65.2336 76.2869 46.8505 76.2829C28.4806 76.2788 18.965 59.6537 18.965 54.108Z\" fill=\"white\" stroke=\"#4D4E58\" stroke-width=\"3.29825\"></path><path d=\"M25.7268 53.009V32.6132C25.7268 32.6132 32.1645 31.8768 36.2895 30.3504C40.4145 28.8241 46.8522 24.7964 46.8522 24.7964L46.8522 69.6401C32.9356 69.6371 25.7268 57.1682 25.7268 53.009Z\" fill=\"#E0E5FF\"></path><ellipse cx=\"47.189\" cy=\"46.7723\" rx=\"11.8302\" ry=\"11.6262\" fill=\"white\" stroke=\"#4D4E58\" stroke-width=\"3.29825\"></ellipse><path d=\"M41.3986 45.839L45.3932 50.176L52.1533 42.7776\" stroke=\"#4D4E58\" stroke-width=\"2.47368\"></path><circle cx=\"70.9126\" cy=\"70.9121\" r=\"13.7427\" transform=\"rotate(-180 70.9126 70.9121)\" fill=\"#7B90FF\"></circle><rect x=\"68.851\" y=\"63.4912\" width=\"4.12281\" height=\"4.12281\" fill=\"white\"></rect><rect x=\"68.851\" y=\"70.0876\" width=\"4.12281\" height=\"10.7193\" fill=\"white\"></rect>", 9)
const _hoisted_11 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  name: 'ShieldExclamation',
  props: {
    size: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_11))
}
}

})